// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2EZbs","paramInput":"JobSimulator_paramInput__2-Hyc","input":"JobSimulator_input__1boNw"};